import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as AccountModel from "../../Common/accountModel";

export const common = (
    state: StoreTypes.ICommon,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): StoreTypes.ICommon => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateState: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, StoreTypes.State>;

            return {
                ...state,
                state: data.parameter,
                errorMessage: "",
            };
        }

        case ActionTypes.Actions.UpdateIsBusy: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isBusy: data.parameter };
        }

        case ActionTypes.Actions.UpdateRecoverState: {
            const newState =
                state.recoverPageState === StoreTypes.TokenState.Initial
                    ? StoreTypes.TokenState.ShowToken
                    : state.recoverPageState;

            return { ...state, recoverPageState: newState };
        }

        case ActionTypes.Actions.ResetRecoverState: {
            return { ...state, recoverPageState: StoreTypes.TokenState.Initial };
        }

        case ActionTypes.Actions.UpdateRegisterState: {
            const newState =
                state.registerPageState === StoreTypes.TokenState.Initial
                    ? StoreTypes.TokenState.ShowToken
                    : state.registerPageState;

            return { ...state, registerPageState: newState };
        }

        case ActionTypes.Actions.ResetRegisterState: {
            return { ...state, registerPageState: StoreTypes.TokenState.Initial };
        }

        case ActionTypes.Actions.UpdateSetExistingClientCredentialsState: {
            const newState =
                state.setExistingClientCredentialsPageState === StoreTypes.TokenState.Initial
                    ? StoreTypes.TokenState.ShowToken
                    : state.setExistingClientCredentialsPageState;

            return { ...state, setExistingClientCredentialsPageState: newState };
        }

        case ActionTypes.Actions.ResetSetExistingClientCredentialsState: {
            return { ...state, setExistingClientCredentialsPageState: StoreTypes.TokenState.Initial };
        }

        case ActionTypes.Actions.SetErrorMessage: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, string>;

            return { ...state, errorMessage: data.parameter };
        }

        case ActionTypes.Actions.UpdateClientData: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, AccountModel.IAccountModel>;

            return { ...state, clientName: data.parameter.clientName };
        }

        case ActionTypes.Actions.UpdateClientPublicId: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, AccountModel.IAccountModel>;

            return { ...state, clientPublicId: data.parameter.clientPublicId };
        }

        default:
            return state;
    }
};
